var map = {
	"./Accessories.png": "f43e",
	"./Accessories_1200x800.png": "9d0b",
	"./Assembling_1200x800.png": "dcd3",
	"./Assembling_new_stock.svg": "862c",
	"./Bleachin_stock.svg": "8fb4",
	"./Bleaching_1200x800.svg": "bfea",
	"./Coating_1200x800.png": "6b86",
	"./Colouring_1200x800.svg": "7a75",
	"./Colouring_stock.svg": "552f",
	"./Component_production_stock.svg": "40f5",
	"./Compounding_1200x800.png": "a3c9",
	"./Confectioning.png": "7b5f",
	"./Confectioning.svg": "23b3",
	"./Confectioning_1200x800.png": "ab8c",
	"./Cotton_Harvest.jpg": "6090",
	"./Cotton_harvest_1200x800.png": "dd6a",
	"./Cutting.png": "7fcc",
	"./Cutting_1200x800.png": "e1e5",
	"./Design_Development.png": "9cc6",
	"./Design_and_development_1200x800.png": "9288",
	"./Drying_stock.svg": "aedc",
	"./Dyeing.png": "159b",
	"./Dyeing_1200x800.png": "dfbb",
	"./Embroidery.png": "1b10",
	"./Embroidery_1200x800.png": "af66",
	"./Exporting.png": "2433",
	"./Exporting_1200x800.png": "7ede",
	"./Fabric_trading.png": "fbdf",
	"./Fabric_trading_1200x800.png": "e5ad",
	"./Finishing.jpg": "bd0a",
	"./Finishing_1200x800.png": "cb31",
	"./Firing_stock.svg": "b18b",
	"./Foam_slicing_stock.svg": "310e",
	"./Foaming_stock.svg": "35e6",
	"./Forming_stock.svg": "ea52",
	"./Ginning.png": "95da",
	"./Ginning_1200x800.png": "2c93",
	"./Glazing_stock.svg": "651d",
	"./Grinding_stock.svg": "c90d",
	"./Importing.png": "1a9a",
	"./Importing_1200x800.png": "207e",
	"./Knitting.jpg": "5698",
	"./Knitting_1200x800.png": "74d8",
	"./Labelling.png": "4da6",
	"./Labelling_1200x800.png": "7952",
	"./Laminating_1200x800.png": "7c62",
	"./Man_made_material.png": "2acb",
	"./Man_made_material_1200x800.png": "22bb",
	"./Manufacturing_1200x800.png": "432f",
	"./Manufacturing_new_stock.svg": "80e9",
	"./Material_production_stock.svg": "3f3b",
	"./Material_trading.png": "ee16",
	"./Material_trading_1200x800.png": "b073",
	"./Melting_stock.svg": "79c9",
	"./Moulding_1200x800.png": "3583",
	"./Natural_material.png": "1fb6",
	"./Natural_material_1200x800.png": "0d10",
	"./Packing.png": "e19e",
	"./Packing_1200x800.png": "7bc9",
	"./Packing_material_stock.svg": "e09f",
	"./Papermaking_stock.svg": "502f",
	"./Printing.png": "c855",
	"./Printing_1200x800.png": "160c",
	"./Product_trading_stock.svg": "14bd",
	"./Pulp_processing_stock.svg": "ab8f",
	"./Raw_material_1200x800.png": "f3f1",
	"./Raw_material_new_stock.svg": "ca82",
	"./Raw_material_processing_stock.svg": "f8be",
	"./Recycled_Material.png": "1704",
	"./Recycled_material_1200x800.png": "6875",
	"./Retailing.png": "6fdf",
	"./Retailing_1200x800.png": "2dfd",
	"./Sewing.png": "31dd",
	"./Sewing_1200x800.png": "2660",
	"./Spinning.png": "82e5",
	"./Spinning_1200x800.png": "939b",
	"./Tanning_1200x800.png": "2a8d",
	"./Trading.svg": "8118",
	"./Transport.png": "5994",
	"./Transport_1200x800.png": "5d78",
	"./Transport_new_stock.svg": "0f87",
	"./Trims.png": "1990",
	"./Trims_1200x800.png": "69fb",
	"./Warehousing.png": "4f08",
	"./Warehousing_1200x800.png": "46b7",
	"./Washing.png": "b314",
	"./Washing_1200x800.png": "500c",
	"./Weaving.png": "3040",
	"./Weaving_1200x800.png": "f449",
	"./Webbing_1200x800.png": "8fe5",
	"./Yarn_trading.png": "576b",
	"./Yarn_trading_1200x800.png": "ef48",
	"./accessories.svg": "1b9d",
	"./assembling.svg": "5ff6",
	"./assembling_new_1200x800.svg": "b51a",
	"./coating.svg": "5df4",
	"./component_production_1200x800.svg": "e1a0",
	"./compounding.svg": "e0a1",
	"./cotton_harvest.svg": "6ad0",
	"./cutting.svg": "6e8a",
	"./design.svg": "7915",
	"./drying_1200x800.svg": "b136",
	"./dyeing.svg": "c3d0",
	"./embroidery.svg": "70d8",
	"./exporting.svg": "a36e",
	"./fabric-trading.svg": "e4ef",
	"./finishing.svg": "f09f",
	"./firing_1200x800.svg": "af55",
	"./foam_slicing_1200x800.svg": "a2d4",
	"./foaming_1200x800.svg": "5cd9",
	"./forming_1200x800.svg": "7b72",
	"./ginning.svg": "8493",
	"./glazing_1200x800.svg": "ad25",
	"./grinding_1200x800.svg": "cc95",
	"./harvest.svg": "053e",
	"./importing.svg": "41ad",
	"./knitting.svg": "2031",
	"./labelling.svg": "3672",
	"./laminating.svg": "2ccb",
	"./man-made-material.svg": "a0a9",
	"./manufacturing.svg": "ddb0",
	"./material-trading.svg": "42a0",
	"./material_production_1200x800.svg": "e284",
	"./melting_1200x800.svg": "2641",
	"./moulding.svg": "ed1f",
	"./natural_material.svg": "daf5",
	"./nextstep.svg": "9c22",
	"./packing.svg": "4792",
	"./packing_material_1200x800.svg": "e508",
	"./packing_new_stock.svg": "ef11",
	"./papermaking_1200x800.svg": "8e10",
	"./printing.svg": "12d6",
	"./product_trading_1200x800.svg": "ef5b",
	"./pulp_processing_1200x800.svg": "fe72",
	"./raw-material.svg": "04b6",
	"./raw_material_processing_1200x800.svg": "465f",
	"./recycled-material.svg": "158b",
	"./retailing.svg": "c20a",
	"./sewing.svg": "f474",
	"./spinning.svg": "7139",
	"./tanning.svg": "27b0",
	"./transport.svg": "2b2c",
	"./trims.svg": "e60d",
	"./warehousing.svg": "13ee",
	"./washing.svg": "1754",
	"./weaving.svg": "a2d1",
	"./webbing.svg": "4225",
	"./yarn-trading.svg": "9add"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0f42";